<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="4" xl="4">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-user"></i>&nbsp;Cliente</b>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xl="9" lg="9" md="10" sm="10" class="mt-1 col-9">
                <CInput label="Documento o celular" v-model="client.document" placeholder="Documento o celular" v-on:keypress="isNumber($event)"
                  @keypress.enter="mtdDocumentClient" />
              </CCol>
              <CCol xl="3" lg="3" md="2" sm="2" class="my-auto mt-1 col-3">
                <CButton class="mt-2 w-100" color="info" v-c-tooltip.hover="{ content: `Buscar documento` }"
                  @click="mtdDocumentClient">
                  <i class="fas fa-search"></i>
                </CButton>
              </CCol>
              <CCol xl="12" lg="12" md="12" sm="12">
                <CInput label="Nombre de cliente" v-model="client.name" placeholder="Nombre de cliente" readonly/>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="8" xl="8">
        <CTableWrapper :items="data_services" :fields="fields" hover :striped="true" :border="true" small fixed
         @mtdBack="mtdBack" caption="Reporte de Clientes" icon="fas fa-calendar" :size="'md'" :withActions="'2%'">
        </CTableWrapper>
      </CCol>
    </CRow>
  </div>
</template>
<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "date", label: "Fecha", _style: "width:10%;" },
  { key: "service", label: "Servicios", _style: "width:10%;" },
  { key: "description", label: "Descripción del Servicio", _style: "width:10%;" },
];
import CTableWrapper from "../shared/datatable/Table.vue";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  components: {
    CTableWrapper,
  },
  name: "report-client",
  data() {
    return {
      fields,
      client: {
        id: "",
        document: "",
        name: "",
      },
      data_services: [],
    }
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtdDocumentClient: function () {
      if (this.client.document.length === 9) {
        this.mtdSearchClientByCE();
        return;
      }

      if (this.client.document.length === 8 || this.client.document.length === 11) {
        this.get({
          url: `${this.$store.getters.get__url}/cita/cliente/${this.$store.getters.get_company.id}/${this.client.document}`,
          token: this.$store.getters.get__token,
        }).then((response) => {

          if (response.data.state === 0) {
            if (
              this.client.document.length === 8 ||
              this.client.document.length === 11
            ) {
              this.mtdSearchDocument();
            } else {
              this.client.name = "";
            }
          } else if (response.statusCode === 200 && response.data.state === 1) {
            this.client.name = response.data.data.name;
            this.mtdViewServices();
          }
        });
      }
    },
    mtdSearchClientByCE: function () {
      this.get({
        url: `${this.$store.getters.get__url}/Consultas/searchCe/${this.client.document}`,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode !== 200) {
            Swal.fire({
              title: "Documento no encontrado",
              icon: "warning",
            });
            this.clearClientData();
            return;
          }

          this.client.name = response.data.name;
          this.mtdViewServices();
        });
    },
    mtdSearchDocument: function () {
      if (this.client.document.length !== 8 && this.client.document.length !== 11) {
        Swal.fire({
          title: "Documento inválido",
          icon: "error",
        });
        return;
      }

      this.get({
        url:
          this.$store.getters.get__url +
          "/Consultas/" +
          this.client.document,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.data.boo === 3) {
            this.clearClientData();
            Swal.fire({
              title: "Documento no encontrado",
              icon: "warning",
            });
          } else {
            this.populateClientData(response.data);
            this.mtdViewServices();
          }
        })
        .catch((error) => {
          console.error("Error al consultar el documento:", error);
          Swal.fire({
            title: "Error en la solicitud",
            text: "Por favor, intente nuevamente más tarde.",
            icon: "error",
          });
        });
    },
    clearClientData: function () {
      this.client.name = "";
      this.client.address = "";
    },
    populateClientData: function (data) {
      if (this.client.document.length === 8) {
        this.client.name = `${data.name} ${data.last_name}`;
      } else {
        this.client.name = data.razon_social;
      }
      this.client.address = data.direccion;
    },
    mtdViewServices: function () {
      if (this.client.name.length > 0) {
        this.get({
          url:
            this.$store.getters.get__url +
            "/cita/getservices/" +
            this.$store.getters.get_company.id +
            "/" +
            this.client.document,
          token: this.$store.getters.get__token,
        }).then((response) => {
          if (response.data.length == 0) {
            this.data_services = [];
            Swal.fire({
              title: "No tiene servicios anteriores!",
              icon: "warning",
            });
          } else {
            this.data_services = response.data;
            let index = 1;
            this.data_services.forEach((item)=>{
              item.date = moment(item.date).format("DD/MM/YYYY");
              item.description = item.detail_service == null ? item.new_detail_service : item.detail_service;
              item.index = index;
              index++;
            });
            
          }
        });
      } else {
        Swal.fire({
          title: "Busque un cliente",
          icon: "warning",
        });
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped></style>
